var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5143 0.592864C16.9111 0.197621 17.3893 0 17.949 0C18.5087 0 18.9869 0.197621 19.3836 0.592864C19.7945 0.988106 20 1.46099 20 2.0115C20 2.56202 19.7945 3.0349 19.3836 3.43014L11.4346 11.3068C11.2646 11.5044 11.0521 11.642 10.797 11.7196C10.542 11.7973 10.2728 11.829 9.98937 11.8149C9.70599 11.8008 9.42614 11.7408 9.14984 11.6349C8.87354 11.5291 8.6362 11.3773 8.43783 11.1797L0.616366 3.43014C0.205455 3.0349 0 2.56202 0 2.0115C0 1.46099 0.205455 0.988106 0.616366 0.592864C0.814736 0.395242 1.0379 0.247026 1.28587 0.148216C1.53383 0.0494053 1.78888 0 2.05101 0C2.31314 0 2.57173 0.0494053 2.82678 0.148216C3.08183 0.247026 3.30854 0.395242 3.50691 0.592864L10.0106 6.98732L16.5143 0.592864Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.2c4f93f5.svg";
export { ForwardRef as ReactComponent };